class AssertionError extends Error {}

interface Assert {
  ok(value: any, message?: string | Error): asserts value
}

export const assert: Assert = {
  ok(value, message) {
    if (!value) {
      if (message instanceof Error) {
        throw message
      } else {
        throw new AssertionError(message || `Expected ${value} to be truthy`)
      }
    }
  }
}
